import { observer } from 'mobx-react-lite'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { history } from '../..'
import { FilterModes } from '../../app/models/modes'

interface Props {
  type: FilterModes
}

function DeletedItemModal({ type }: Props) {
  const { t } = useTranslation()

  const getName = (): string => {
    if (type === FilterModes.auction) {
      return 'Action'
    } else {
      return 'Post'
    }
  }

  const name = getName()

  const handleRedirect = () => {
    if (type === FilterModes.auction) {
      history.push('/auctions')
    } else {
      history.push('/posts')
    }
  }

  return (
    <div className='newFont prevent-select'>
      <Modal
        show={true}
        aria-labelledby='contained-modal-title-vcenter'
        backdrop='static'
        keyboard={false}
        size='lg'
        centered
      >
        <Modal.Header className='bg-white'>
          <p className='post-card-title'>{t('deleted.title', { name: name })}</p>
        </Modal.Header>
        <Modal.Body className='post-card-padding pt-5 card-font-size'>
          <p className='text-center'>
          {t('deleted.description', { name: name })}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={handleRedirect} className='payment-button-cancel text-white'>
            {t('go_back')}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
export default DeletedItemModal
